import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { API_URL_All } from '../api';
import axiosInstance from '../axiosInstance';
import AdminLayout from '../components/AdminLayout';
import * as general from '../libs/general';
import { toast } from "react-toastify";
import { fetchSettingsPermissions } from "../libs/customerCreatePermission";


const OrderParameter = () => {

  const [model, setModel] = useState({});
  const [title, setTitle] = useState('');
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [key, setKey] = useState(0);
  const [settingsPerm, setSettingsPerm] = useState({
    loaded: false,
    canView: false,
    canEdit: false,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const p = await fetchSettingsPermissions(axiosInstance);
      if (cancelled) return;
      setSettingsPerm({
        loaded: true,
        canView: Boolean(p?.canView),
        canEdit: Boolean(p?.canEdit),
      });
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!settingsPerm.loaded || !settingsPerm.canView) return;
    const fetchPageContents = async () => {
      try {
        var requestApi = `/api/import-orders/getSetting`;
        const response = await axiosInstance.get(requestApi);
        console.log(response.data.data);

        setModel(response.data.data);

        setTitle('Cài đặt đơn hàng');

      } catch (error) {
        toast.error(error.message, { position: "top-right" });
        console.error("Error fetching :", error);
      }
    };

    fetchPageContents();
  }, [key, settingsPerm.loaded, settingsPerm.canView]);

  const saveSetting = async () => {
    if (!settingsPerm.canEdit) {
      toast.warning("Bạn không có quyền cập nhật.", { position: "top-right" });
      return;
    }
    try {
      var requestApi = `/api/import-orders/saveSetting`;
      const response = await axiosInstance.post(requestApi, model);
      if (!response.data.success) {
        toast.error(response.data.message, { position: "top-right" });
        return;
      }

      toast.success(response.data.message, { position: "top-right" });
    } catch (error) {
      toast.error(error.message, { position: "top-right" });
      console.error("Error fetching :", error);
    }
  };

  return (
    <div>
      <AdminLayout>
        {settingsPerm.loaded && !settingsPerm.canView ? (
          <div className="container-fluid p-3 p-md-4">
            <div className="alert alert-warning mb-0">Bạn không có quyền truy cập màn hình này.</div>
          </div>
        ) : (
        <>
        <div className="right_col" role="main">
          <div className="row">
            <div className="col-md-12 col-sm-12 ">
              <div className="x_panel">
                <div className="x_title">
                  <h2 className="fw-bold">Cài đặt đơn hàng</h2>
                  <ul className="nav navbar-right panel_toolbox">
                  </ul>
                  <div className="clearfix"></div>
                </div>
                <div className="x_content calc-200">
                  <form id="form_colors" className="" action="" method="post" noValidate>
                    <div className="table-s table-normal">
                      <table>
                        <tbody>
                          <tr>
                            <th width="50px">STT</th>
                            <th>Tên</th>
                            <th><span data-note="kg">Giá trị</span></th>
                            <th>Mô tả</th>
                          </tr>
                          <tr>
                            <td>1</td>
                            <td className="cell-normal"><span>Trọng lượng nhỏ nhất</span></td>
                            <td>
                              <input type="number" className="form-control" readOnly={!settingsPerm.canEdit} value={model.minWeight} onChange={(e) => setModel({ ...model, minWeight: e.target.value })} />
                            </td>
                            <td className="cell-normal">Nếu trọng lượng đơn hàng nhỏ hơn giá trị này thì áp dụng phí theo giá trị này.</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="ln_solid1">
                      <div className="form-group">
                        <div className="col-12 text-center">
                          <button type='reset' className="btn-s btn btn-success" disabled={!settingsPerm.canEdit} onClick={(event) => setKey(prev => prev + 1)}>Hủy</button>
                          <button type='button' className="btn-s btn btn-primary" disabled={!settingsPerm.canEdit} onClick={saveSetting}>Lưu</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>


          </div>
        </div>
        <footer className="d-none"> </footer>
        </>
        )}
      </AdminLayout>
    </div>
  );
};

export default OrderParameter;